<script setup lang="ts">
import ImportadorView from '@/views/ImportadorView.vue'
</script>

<template>
  <ImportadorView />
</template>

<style>
html {
  overflow-y: auto !important;
}

body {
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
